import { render, staticRenderFns } from "./rectify.vue?vue&type=template&id=a07134a0&scoped=true"
import script from "./rectify.vue?vue&type=script&lang=js"
export * from "./rectify.vue?vue&type=script&lang=js"
import style0 from "./rectify.vue?vue&type=style&index=0&id=a07134a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07134a0",
  null
  
)

export default component.exports